export default __webpack_public_path__ + "static/media/css.83b5773d.svg";